import RoleCustomPermission from "@/core/services/user/role/RoleCustomPermission";

const roleCustomService = new RoleCustomPermission();
const UserPermission = {

    state: {
        permissions: [],
        user_roles: []
    },
    getters: {
        getPermissions(state) {
            return state.permissions;
        },
        getUserRoles(state) {
            return state.user_roles;
        },
    },
    actions: {
        GET_USER_PERMISSIONS: (context, payload) => {
            let config = JSON.parse(localStorage.getItem('conf'));
            if (config && config.length > 0) {
                context.commit('SET_USER_PERMISSIONS', config);
            } else {
                roleCustomService.userPermissionList().then(response => {
                        localStorage.setItem('conf', JSON.stringify(response.data.permissions))
                        context.commit('SET_USER_PERMISSIONS', response.data.permissions);
                    }
                ).catch(error => {
                    localStorage.removeItem('conf')
                })
            }
        }
    },
    mutations: {
        SET_USER_PERMISSIONS: (state, payload) => {
            state.permissions = payload
        },
        SET_USER_ROLES: (state, payload) => {
            state.user_roles = payload
        }
    }
    ,
}
export default UserPermission;